import React from 'react'

const BrianHanly = () =>
  <div className="page bio">
    Brian Hanly
  </div>

export default BrianHanly
